module.exports = __webpack_public_path__ + "static/media/tag.ebec76d4.svg";